module.exports = __webpack_public_path__ + "static/assets/968680284c4fc84e16ab59b33e9515d4.png";